import { UIOptions } from './UI';

export { default as ScreenSet } from './screens/ScreenSet';

/**
 * Returns a Promise of a new UI instance
 *
 * @param {HTMLElement} el The HTML elemetn to render the UI to
 * @param {UIOptions} [options] An optional list of options for the UI instance
 */
export async function create(el?: HTMLElement, options?: UIOptions) {
    const { default: UI } = await import('./UI');
    return new UI(el, options);
}
